import React from 'react'
import classnames from 'classnames'

class Tooltip extends React.Component {
	toolTipContent = () => {
		const toolTipClass = classnames('tooltip', {
			'tooltip--top': this.props.tooltipPosition === 'above',
			'tooltip--right': this.props.tooltiplLRPosition === 'right',
		})
		return (
			<div className={toolTipClass} role="tooltip">
				<span className="tooltip__text">{this.props.tooltipText}</span>
			</div>
		)
	}

	render() {
		return (
			<div className="tooltip-container">
				{this.props.tooltipPosition === 'above' ? this.toolTipContent() : ''}
				{this.props.children}
				{this.props.tooltipPosition !== 'above' ? this.toolTipContent() : ''}
			</div>
		)
	}
}

export default Tooltip
